export interface ILatestSensorDataValues extends Record<SensorDataValueType, ISensorDataValue>
{
}

export class LatestSensorDataValues {
    constructor(values: ILatestSensorDataValues ) {
        this.values = values;

        if (!this.values[SensorDataValueType.VehicleId]) {
            return;
        }

        this.vehicleId = this.values[SensorDataValueType.VehicleId].Value;
    }

    public getValue<type>(sensorDataType: SensorDataValueType): type {

        var sensorDataValue = this.values[sensorDataType];

        if (!sensorDataValue) {
            return null;
        }

        return sensorDataValue.Value as type;
    }

    values: ILatestSensorDataValues;

    vehicleId: number
}

export interface ISensorDataValue {
    EventTime: Date;
    Value: any;
    ValueLabel: string;
    Icon?: string;
}

export enum SensorDataValueType {
    AdBlueLevel = 0,
    BatteryLevel = 1,
    CruiseActive = 2,
    EngineRpm = 3,
    Odometer = 4,
    OdometerKm = 5,
    Velocity = 6,
    Kpl = 7,
    FuelLevel = 8,
    OdometerKmCan = 9,
    PtoActive = 10,
    TachoSlot1Driver = 11,
    TachoSlot1WorkState = 12,
    TachoSlot1TimeState = 13,
    TachoSlot1DrivingTime = 14,
    TachoSlot2Driver = 15,
    TachoSlot2WorkState = 16,
    TachoSlot2TimeState = 17,
    TachoSlot2DrivingTime = 18,
    ThrottlePosition = 19,
    TotalWeight = 20,
    TrailerId = 21,
    TrailerConnected = 22,
    VehicleIdentificationNumber = 23,
    VelocityCan = 24,
    Header = 25,
    Profile = 26,
    ExtendedInfo = 27,
    TotalDuration = 28,
    Axle1Weight = 30,
    Axle2Weight = 31,
    Axle3Weight = 32,
    Axle4Weight = 33,
    BrakeApplications = 34,
    BrakeLowSpeedApplications = 35,
    BrakeMedSpeedApplications = 36,
    BrakeHighSpeedApplications = 37,
    BrakeApplicationsOverThreshold = 38,
    BrakeDistance = 39,
    BadAnticipationCount = 40,
    CoastingDuration = 41,
    CoastingDistance = 42,
    CruiseDuration = 43,
    CruiseDistance = 44,
    CruisePotentialDistance = 45,
    CruiseWhileInTopGearDistance = 46,
    DrivingDuration = 51,
    EcoRollDistance = 52,
    EmptyRunningDistance = 53,
    EmptyRunningFuelUsed = 54,
    EngineOnDuration = 55,
    EngineBrakeApplications = 56,
    EngineBrakeLowTorqueDuration = 57,
    EngineBrakeMedTorqueDuration = 58,
    EngineBrakeHighTorqueDuration = 59,
    FuelUsedCruise = 60,
    FuelUsedDriving = 61,
    FuelUsedIdle = 62,
    FuelUsedIdleExclusive = 63,
    FuelUsedPto = 64,
    FuelUsedTotal = 65,
    FuelType = 66,
    IdlingDuration = 67,
    IdlingDurationExclusive = 68,
    OverAccelerationDuration = 69,
    OverAccelerationDurationLowThreshold = 70,
    OverAccelerationDurationHighThreshold = 71,
    OverIdlingDuration = 72,
    OverIdlingDurationLowThreshold = 73,
    OverIdlingDurationMedThreshold = 74,
    OverIdlingDurationHighThreshold = 75,
    OverIdlingCount = 76,
    OverRevDuration = 77,
    OverRevDurationLowThreshold = 78,
    OverRevDurationMedThreshold = 79,
    OverRevDurationHighThreshold = 80,
    OverRevDistance = 81,
    OverRevDistanceLowThreshold = 82,
    OverRevDistanceMedThreshold = 83,
    OverRevDistanceHighThreshold = 84,
    OverSpeedDuration = 85,
    OverTorqueDuration = 86,
    OverTorqueDistance = 87,
    PtoDuration = 88,
    PtoActiveDuration = 89,
    TopGearDistance = 90,
    TravelStopEventCount = 91,
    PrimaryAuxEngineSource = 92,
    PrimaryAuxEngineOnDuration = 93,
    PrimaryAuxElectricOnDuration = 94,
    PrimaryAuxStandbyOnDuration = 95,
    PrimaryAuxEngineFuelLevel = 96,
    PrimaryAuxBatteryVoltage = 97,
    VehicleId = 98,
    CoastingInclusiveDuration = 99,
    CoastingInclusiveDistance = 100,
    CruiseWhileInTopGearDuration = 101,
    GreenBandDistanceLowThreshold = 102,
    GreenBandDistanceMedThreshold = 103,
    GreenBandDistanceHighThreshold = 104,
    GreenBandDurationLowThreshold = 105,
    GreenBandDurationMedThreshold = 106,
    GreenBandDurationHighThreshold = 107,
    SweetSpotDistanceLowThreshold = 108,
    SweetSpotDistanceMedThreshold = 109,
    SweetSpotDistanceHighThreshold = 110,
    SweetSpotDurationLowThreshold = 111,
    SweetSpotDurationMedThreshold = 112,
    SweetSpotDurationHighThreshold = 113,
    RolloverStabilityControlMinorCount = 114,
    RolloverStabilityControlMinorDuration = 115,
    RolloverStabilityControlMajorCount = 116,
    RolloverStabilityControlMajorDuration = 117,
    AverageVelocity = 118,
    Distance = 119,
    DistanceKm = 120,
    OdometerKmStart = 121,
    OdometerKmEnd = 122,
    MaxVelocity = 123,
    DistanceKmCan = 124,
    FuelLevelStart = 125,
    FuelLevelEnd = 126,
    OdometerKmCanStart = 127,
    OdometerKmCanEnd = 128,
    CommonEventCount = 129,
}
